// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XMR4","icon":"styles_icon__3YS4t"};